import type { ReactNode } from 'react';
import Menu, { MenuDivider, type MenuProps } from '@/components/Menu';
import { DeleteIcon, EditIcon } from '@/icons';
import MenuOption, { type MenuOptionProps } from './MenuOption';
import { classes } from './utils';

export { MenuOption, MenuDivider, type MenuOptionProps };

export type DefaultOptionsMenuProps = {
  open: boolean;
  separateDelete?: boolean;
  className?: string;
  anchorTo: HTMLElement | null;
  anchorOrigin?: MenuProps['anchorOrigin'];
  transformOrigin?: MenuProps['transformOrigin'];
  extraOptions?: ReactNode;
  onEdit?: () => void;
  onDelete?: () => void;
  onClose: () => void;
};

export default function DefaultOptionsMenu({
  open,
  separateDelete,
  className = '',
  anchorTo,
  anchorOrigin,
  transformOrigin,
  extraOptions,
  onEdit,
  onDelete,
  onClose,
}: DefaultOptionsMenuProps) {
  return (
    <Menu
      open={open}
      className={className}
      anchorTo={anchorTo}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      onClose={onClose}>
      {extraOptions}
      {onEdit && (
        <MenuOption
          label="Edit"
          icon={<EditIcon size={20} />}
          onClick={onEdit}
        />
      )}
      {onDelete && separateDelete && <MenuDivider />}
      {onDelete && (
        <MenuOption
          className={classes.deleteIcon}
          label="Delete"
          icon={<DeleteIcon className={classes.deleteIcon} size={20} />}
          onClick={onDelete}
        />
      )}
    </Menu>
  );
}
